import { Box, Grid, Typography } from '@mui/material';
import { memo } from 'react';

import { GroupStatusIcon } from '../../components/StatusIndicators';
import { isGroupComplete } from '../../utils/completionUtils';
import { INF_STATISTIC_FIELD_LABELS } from '../constants';
import { OutliersSection } from '../types';

interface OutliersProps {
  outliers: OutliersSection;
}

export const Outliers = memo(function Outliers(props: OutliersProps) {
  const { outliers } = props;

  return (
    <Grid id="inf-outliers" container spacing={2} marginBottom={3}>
      <Grid item xs={12}>
        <Box display="flex" alignItems="center" gap={1}>
          <GroupStatusIcon isComplete={isGroupComplete(outliers)} />
          <Typography my={2} fontWeight={600}>
            Outliers do Modelo de Regressão
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={3}>
        <Typography variant="caption" color="text.secondary">
          {INF_STATISTIC_FIELD_LABELS.outliers_quantity}
        </Typography>
        <Typography>{outliers.outliers_quantity ?? '-'}</Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography variant="caption" color="text.secondary">
          {INF_STATISTIC_FIELD_LABELS.outliers_percentage}
        </Typography>
        <Typography>
          {outliers.outliers_percentage != null
            ? `${outliers.outliers_percentage} %`
            : '-'}
        </Typography>
      </Grid>
    </Grid>
  );
});
